module.exports = __webpack_public_path__ + "img/first-icon.ca2ae90e.png";